var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrammarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4384_30077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4384_30077)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4384_30077)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4384_30077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6257 17.125C16.5462 16.8485 16.4344 16.6042 16.2905 16.392C16.1465 16.1761 15.9704 15.9943 15.7621 15.8466C15.5575 15.6951 15.3227 15.5795 15.0575 15.5C14.7962 15.4205 14.5064 15.3807 14.1882 15.3807C13.5935 15.3807 13.0708 15.5284 12.62 15.8239C12.1731 16.1193 11.8246 16.5492 11.5746 17.1136C11.3246 17.6742 11.1996 18.3598 11.1996 19.1705C11.1996 19.9811 11.3227 20.6705 11.5689 21.2386C11.8151 21.8068 12.1636 22.2405 12.6143 22.5398C13.0651 22.8352 13.5973 22.983 14.2109 22.983C14.7678 22.983 15.2431 22.8845 15.6371 22.6875C16.0348 22.4867 16.3378 22.2045 16.5462 21.8409C16.7583 21.4773 16.8643 21.0473 16.8643 20.5511L17.3643 20.625H14.3643V18.7727H19.2337V20.2386C19.2337 21.2614 19.0178 22.1402 18.5859 22.875C18.1541 23.6061 17.5594 24.1705 16.8018 24.5682C16.0443 24.9621 15.1768 25.1591 14.1996 25.1591C13.1087 25.1591 12.1503 24.9186 11.3246 24.4375C10.4988 23.9527 9.85488 23.2652 9.39276 22.375C8.93442 21.4811 8.70526 20.4205 8.70526 19.1932C8.70526 18.25 8.84162 17.4091 9.11435 16.6705C9.39086 15.928 9.77723 15.2992 10.2734 14.7841C10.7696 14.2689 11.3473 13.8769 12.0064 13.608C12.6655 13.339 13.3795 13.2045 14.1484 13.2045C14.8075 13.2045 15.4212 13.3011 15.9893 13.4943C16.5575 13.6837 17.0613 13.9527 17.5007 14.3011C17.9439 14.6496 18.3056 15.0644 18.5859 15.5455C18.8662 16.0227 19.0462 16.5492 19.1257 17.125H16.6257ZM31.3487 17.4375H28.8601C28.8146 17.1155 28.7218 16.8295 28.5817 16.5795C28.4415 16.3258 28.2616 16.1098 28.0419 15.9318C27.8222 15.7538 27.5684 15.6174 27.2805 15.5227C26.9964 15.428 26.6877 15.3807 26.3544 15.3807C25.7521 15.3807 25.2275 15.5303 24.7805 15.8295C24.3336 16.125 23.987 16.5568 23.7408 17.125C23.4946 17.6894 23.3714 18.375 23.3714 19.1818C23.3714 20.0114 23.4946 20.7083 23.7408 21.2727C23.9908 21.8371 24.3393 22.2633 24.7862 22.5511C25.2332 22.839 25.7502 22.983 26.3374 22.983C26.6669 22.983 26.9718 22.9394 27.2521 22.8523C27.5362 22.7652 27.7881 22.6383 28.0078 22.4716C28.2275 22.3011 28.4093 22.0947 28.5533 21.8523C28.701 21.6098 28.8033 21.3333 28.8601 21.0227L31.3487 21.0341C31.2843 21.5682 31.1233 22.0833 30.8658 22.5795C30.612 23.072 30.2692 23.5133 29.8374 23.9034C29.4093 24.2898 28.898 24.5966 28.3033 24.8239C27.7124 25.0473 27.0438 25.1591 26.2976 25.1591C25.2597 25.1591 24.3317 24.9242 23.5135 24.4545C22.6991 23.9848 22.0552 23.3049 21.5817 22.4148C21.112 21.5246 20.8771 20.447 20.8771 19.1818C20.8771 17.9129 21.1158 16.8333 21.593 15.9432C22.0703 15.053 22.718 14.375 23.5362 13.9091C24.3544 13.4394 25.2749 13.2045 26.2976 13.2045C26.9718 13.2045 27.5968 13.2992 28.1726 13.4886C28.7521 13.678 29.2654 13.9545 29.7124 14.3182C30.1593 14.678 30.523 15.1193 30.8033 15.642C31.0874 16.1648 31.2692 16.7633 31.3487 17.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4384_30077",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30077",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4384_30077",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30077",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4384_30077",
    x: 6.2716,
    y: 13.2046,
    width: 27.5108,
    height: 16.8219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30077",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4384_30077",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#082CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#000F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammarChart);
export default __webpack_public_path__ + "static/media/GrammarChart.48085abb9a485f305fe0feb5454636e2.svg";
export { ForwardRef as ReactComponent };